import React from "react";
import {
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
//import { intlFormatMessage } from "../../../utils/utils";
//import { common } from "../../../messages";
//import { useIntl } from "react-intl";

export default function CouponFormat({ values, handleChange }) {
  //const intl = useIntl();

  const currentValue = values.coupon_format ?? "QR"; // fallback a "QR"

  return (
    <FormControl margin="normal">
      <InputLabel>Coupon format</InputLabel>
      <Select
        value={currentValue}
        onChange={handleChange("coupon_format")}
        input={<Input />}
      >
        {[
          { value: "QR", label: "QR Code" },
          { value: "none", label: "None" },
        ].map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
